var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"roboto-font"},[_c('section',{staticClass:"home-hero"},[_c('div',{staticClass:"container home-hero__content"},[_c('HomePrompt'),_vm._v(" "),_c('CommonEducationBrandsBlock',{attrs:{"block":_vm.logoBeltBlock}})],1)]),_vm._v(" "),_c('HomeTestimonials'),_vm._v(" "),_c('HomePricing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }